import { createSlice } from "@reduxjs/toolkit";

const serviceRequestSlice = createSlice({
    name: "serviceRequests",
    initialState: {},
    reducers: {
        registerServiceRequest: (state, action) => {
            const request = action.payload;
            if (!request?.id) return;

            if (!state[request.id]) {
                state[request.id] = request;
            } else {
                console.warn(
                    `⚠️ ServiceRequest ${request.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterServiceRequests: (state, action) => {
            action.payload.forEach((request) => {
                if (!request?.id) return;

                if (!state[request.id]) {
                    state[request.id] = request;
                } else {
                    console.warn(
                        `⚠️ ServiceRequest ${request.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerServiceRequest,
    bulkRegisterServiceRequests
} = serviceRequestSlice.actions;

export default serviceRequestSlice.reducer;
